const download = require("downloadjs");

export default download;
